import { createContext } from 'react';

import type {
  Permission,
  PermissionAction,
  PermissionResource,
} from 'src/domains/business/user-management/types';

// ----------------------------------------------------------------------

type PermissionsContextType = {
  permissions: Permission[];
  loading: boolean;
  error: unknown;
  refresh: () => Promise<void>;
  hasPermission: (resource: PermissionResource, action: PermissionAction) => boolean;
};

export const PermissionsContext = createContext<PermissionsContextType | null>(null);
